import common from '@/api/common'
import rules from './rules'

export default {
  data () {
    return {
      formRules: {
        phone: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!rules.phone(value)) {
              callback(new Error('请输入正确的手机号'))
            } else {
              if (this.formRules.phonePass === value) {
                callback()
              } else {
                common.checkPhone(value, this.formRules.userUuid).then(res => {
                  if (res) {
                    this.formRules.phonePass = value
                    callback()
                  } else {
                    callback(new Error('该手机号已经被注册'))
                  }
                })
              }
            }
          },
          trigger: 'blur'
        }],
        idNumber: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!rules.idNumber(value)) {
              callback(new Error('请输入正确的证件号码'))
            } else {
              // 避免验证所有表单时，重复请求
              if (this.formRules.idNumberPass === value) {
                callback()
              } else {
                common.checkIdNumber(value, this.formRules.userUuid).then(res => {
                  if (res) {
                    this.formRules.idNumberPass = value
                    callback()
                  } else {
                    callback(new Error('该身份证号已经被注册'))
                  }
                })
              }
            }
          },
          trigger: 'blur'
        }],
        idName: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请输入教练员姓名'))
            }
          },
          trigger: 'blur' }],
        gender: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请选择性别'))
            }
          },
          trigger: 'change' }],
        position: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请选择球员位置'))
            }
          },
          trigger: 'change' }],
        squadUuid: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请选择球队'))
            }
          },
          trigger: 'change' }],
        youthUuid: [{ required: true, message: '请选择单位', trigger: 'change' }],
        unit: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请输入单位名称'))
            }
          },
          trigger: 'blur' }],
        organUuid: [{ required: true, message: '请选择管理单位', trigger: 'change' }],
        squadForCoach: [{ required: true, message: '请选择球队', trigger: 'change' }],
        idNumberPass: '',
        phonePass: '',
        testRegion: [{ required: true, message: '请选择测试海拔', trigger: 'change' }],
        templateUuid: [{ required: true, message: '请选择测试数据模板', trigger: 'change' }]
      }
    }
  }
}
